import "@jpj/ui/reset.css";
import "@jpj/ui/components.css";
import "./styles/theme.css";
import "./styles/game.css";

import { $ } from "./dom";
import { hideOverlay, runTeaser } from "@jpj/game-shell";
import { warmUpHighs } from "@jpjj/solver-core";
import {
  buildDots, goNext, goPrev, loadLevel, recompute, resetLevel, restartGame, startGame,
} from "./game/flow";
import { initInteraction } from "./game/interaction";
import { skipCompare, nextCompare } from "./reveal/reveal";
import { openLearn, closeLearn, stepLearn } from "./reveal/learn";
import { state } from "./game/state";
import { LEVELS } from "./game/levels";
import type { GridCell } from "./game/types";

/* ---------- Nav + controls ---------- */
$("prevBtn").addEventListener("click", goPrev);
$("nextBtn").addEventListener("click", goNext);
$("resetBtn").addEventListener("click", resetLevel);

/* ---------- Reveal / explainer buttons (always present in the DOM) ---------- */
$("cmpSkip").addEventListener("click", skipCompare);
$("cmpNext").addEventListener("click", nextCompare);
$("learnBtn").addEventListener("click", openLearn);
$("again2").addEventListener("click", () => {
  hideOverlay("solverOverlay");
  restartGame();
});
$("learnBack").addEventListener("click", closeLearn);
$("lPrev").addEventListener("click", () => stepLearn(-1));
$("lNext").addEventListener("click", () => stepLearn(1));

/* ---------- Intro ---------- */
const beginGame = (): void => {
  hideOverlay("introOverlay");
  startGame();
};
$("beginBtn").addEventListener("click", beginGame);

/* ---------- Init ---------- */
// the title scene stays up until the player picks "How to Play" or "Start"
runTeaser({ onStart: beginGame });
initInteraction();
buildDots();
// warm up the HiGHS Web Worker during the intro so the reveal is instant
warmUpHighs();
// preload the first labyrinth behind the intro so the dungeon looks ready
loadLevel(0);

/* ---------- Headless verification hooks (used by scripts/verify.mjs) ---------- */
declare global {
  interface Window {
    __lk: {
      state: typeof state;
      levels: typeof LEVELS;
      setWalls(cells: GridCell[]): void;
      recompute(): void;
      goNext(): void;
      reset(): void;
      restart(): void;
    };
  }
}
window.__lk = {
  state,
  levels: LEVELS,
  setWalls(cells: GridCell[]): void {
    state.walls = cells.map((c) => [c[0], c[1]] as GridCell);
    recompute();
  },
  recompute,
  goNext,
  reset: resetLevel,
  restart: restartGame,
};
